const uuidRegex = /^[\da-f]{8}(?:-[\da-f]{4}){3}-[\da-f]{12}$/i;

export const isUuidUtil = (uuid: string): boolean => uuidRegex.test(uuid);
